// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumbs-FIo";
export var crumb = "crumb-HGq";